import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const ViewOptionContext = React.createContext(null);
export const ViewOptionContextProvider = ({ options, children, }) => {
    return _jsx(ViewOptionContext.Provider, { value: options, children: children });
};
export const useViewOptions = () => {
    const options = React.useContext(ViewOptionContext);
    // if (options === null) {
    //   throw new Error("useViewOptions must be used within a ViewOptionContextProvider");
    // }
    return options;
};
export function createUseViewOptions() {
    return function useAppViewOptions(_view) {
        return useViewOptions();
    };
}
//# sourceMappingURL=viewOptionContext.js.map